import axios from 'axios'

export default axios.create({
  baseURL: `${process.env.REACT_APP_WBO}/api`,
  withXSRFToken: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
})

export const axiosPrivateWBO = axios.create({
  baseURL: `${process.env.REACT_APP_WBO}/api`,
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
})
